import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider, useApp } from "./state/AppContext";
import LanguageScreen from "./screens/LanguageScreen";
import WelcomeScreen from "./screens/WelcomeScreen";
import HomeScreen from "./screens/HomeScreen";
import GalleryScreen from "./screens/GalleryScreen";
import DetailScreen from "./screens/DetailScreen";
import ActivitiesScreen from "./screens/ActivitiesScreen";
import SubmitScreen from "./screens/SubmitScreen";
import LeaderboardScreen from "./screens/LeaderboardScreen";
import AdminScreen from "./screens/AdminScreen";
import KindnessWallScreen from "./screens/KindnessWallScreen";
import QRScreen from "./screens/QRScreen";
import VanityRedirect from "./components/VanityRedirect";
import ParentScreen from "./screens/ParentScreen";
import BottomNav from "./components/BottomNav";
import UserMenuButton from "./components/UserMenuButton";
import { Toaster } from "sonner";

function ScreenRouter() {
  const { screen, user, hasLangChoice } = useApp();
  if (!hasLangChoice) return <LanguageScreen />;
  // Kindness path is gated: gallery / detail / submit / mine / leaderboard require signup.
  // Activities, home, and QR are public.
  const requiresUser = ["gallery", "detail", "submit", "mychallenges", "leaderboard"].includes(screen);
  if (screen === "welcome" || (requiresUser && !user)) return <WelcomeScreen />;
  if (screen === "language") return <LanguageScreen />;
  if (screen === "home") return <HomeScreen />;
  if (screen === "qr") return <QRScreen />;
  if (screen === "activities") return <ActivitiesScreen />;
  if (screen === "gallery") return <GalleryScreen />;
  if (screen === "detail") return <DetailScreen />;
  if (screen === "submit") return <SubmitScreen />;
  if (screen === "mychallenges") return <LeaderboardScreen defaultTab="mine" />;
  if (screen === "leaderboard") return <LeaderboardScreen defaultTab="board" />;
  return <HomeScreen />;
}

function MainApp() {
  return (
    <div className="min-h-screen bg-scl-cream">
      <div className="mx-auto max-w-[480px] min-h-screen relative bg-scl-cream shadow-2xl">
        <UserMenuButton />
        <ScreenRouter />
        <BottomNav />
      </div>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppProvider>
        <Routes>
          <Route path="/admin" element={<AdminScreen />} />
          <Route path="/parent" element={<ParentScreen />} />
          <Route path="/wall" element={<KindnessWallScreen />} />
          <Route path="/go/kindness" element={<VanityRedirect target="kindness" />} />
          <Route path="/go/activity" element={<VanityRedirect target="activity" />} />
          <Route path="*" element={<MainApp />} />
        </Routes>
        <Toaster position="top-center" richColors closeButton />
      </AppProvider>
    </BrowserRouter>
  );
}
